import { render } from "./MediaModal.vue?vue&type=template&id=304563d7&lang=pug"
import script from "./MediaModal.vue?vue&type=script&lang=js"
export * from "./MediaModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__